// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2qraS","additionalInfo":"AgreementModal_additionalInfo__2IqHg"};